import { render } from "./event-type.vue?vue&type=template&id=7881a264&lang=pug"
import script from "./event-type.vue?vue&type=script&lang=js"
export * from "./event-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__